// extracted by mini-css-extract-plugin
export default {"miniSiteWrapper":"miniSite_miniSiteWrapper__+p0SG","editButton":"miniSite_editButton__BH9fX"};